import React, { useEffect, useState, useRef } from "react";
import * as XLSX from "xlsx";
import axios from "axios";
import Header from "./gapsy-header";
import Navigation from "./gapsy-Anavigation";
import Footer from "./gapsy-footer";
import styles from "../assets/css/gapsy-dashboard.module.css";
import tableStyles from "../assets/css/sharedTableStyles.module.css";
import { uploadMutiple, templatedata, Bulkuploaddata, shariahremarks, previewrdmdata, updateshariahoverride, checkboxapprove, updatetextfile3001, checkboxreject, rejectrdmdata, approverdmdata } from '../components/ApiProperty';
import { Modal, Button, Form } from 'react-bootstrap';
import { Aprrovecolor, Rejectcolor, submitButtonStyle, cancelButtonStyle, ProceedButtonStyle, UploadLoadingIcon } from "../components/Propertyfile";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";


const GapsyResidualOverride = () => {
    const [sheetData, setSheetData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [indexRows, setIndexRows] = useState([]);
    const [messageType, setMessageType] = useState(''); // 'success' or 'error'
    const [modalMessage, setModalMessage] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showNotifyModal, setShowNotifyModal] = useState(false);
    const [operationalRiskCharge, setOperationalRiskCharge] = useState("");
    const [tempData, setTempData] = useState([]);
    const [liveData, setLiveData] = useState([]);
    const [makerRemarks, setMakerRemarks] = useState("");
    const [showReportingModal, setShowReportingModal] = useState(false);
    const [showReportingModal1, setShowReportingModal1] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [reportingMessage, setReportingMessage] = useState("");
    const [allowSubmit, setAllowSubmit] = useState(true);
    const [isViewMode, setIsViewMode] = useState(false);
    const [inputValue, setInputValue] = useState("");
    const [inputValue1, setInputValue1] = useState("");
    const [showmakerRemarks, SetshowMakerremarks] = useState(false);
    const [showmakerRemarks1, SetshowMakerremarks1] = useState(false);
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [selectedColumn, setSelectedColumn] = useState("");
    const [otherReason, setOtherReason] = useState("");
    const [showConfirmApprove, setShowConfirmApprove] = useState(false);
    const [rejectedReason, setRejectedReason] = useState("");
    const [showDownload, setShowDownload] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [q1, setQ1] = useState("");
    const [q2, setQ2] = useState("");
    const [q3, setQ3] = useState("");
    const [reportingDate, setReportingDate] = useState(
        localStorage.getItem("selectedReportingDate") || ""
    );
    let csrfToken = sessionStorage.getItem("tokenizedSession");
    const userId = localStorage.getItem("userid");
    const [showErrorModal, setShowErrorModal] = useState(false);
    const department = sessionStorage.getItem("dept");
    const [initialIndexRows, setInitialIndexRows] = useState([]);
    const [initialGradeRows, setInitialGradeRows] = useState([]);
    const [gradeRows, setGradeRows] = useState([]);
    const [excelLoaded, setExcelLoaded] = useState(false);
    const [availableReportingDates, setAvailableReportingDates] = useState([]);
    const [previewSheetData, setPreviewSheetData] = useState(null);
    const [showActionButtons, setShowActionButtons] = useState(true);
    const [showChargeModal, setShowChargeModal] = useState(false);
    const [statusData, setStatusData] = useState([]);
    const [selectedReportingDate1, setselectedReportingDate1] = useState([]);
    const [reportingDates1, setReportingDates1] = useState([]);
    const [capitalChargeData, setCapitalChargeData] = useState([]);
    const [isTemplateDownloaded, setIsTemplateDownloaded] = useState(false);
    const [isConfirmed, setIsConfirmed] = useState(false);
    const [isFileUploaded, setIsFileUploaded] = useState(false);
    const [isPreviewCompleted, setIsPreviewCompleted] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const fileInputRef = useRef(null);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [selectedReportingDate, setSelectedReportingDate] = useState("");
    const [confirmationAction, setConfirmationAction] = useState("");
    // const reportingDate = localStorage.getItem("selectedReportingDate");

    const getStoredReportingDate = () => {
        return String(
            localStorage.getItem("selectedReportingDate") || ""
        ).trim();
    };

    useEffect(() => { loadExcel(); }, []);

    const fetchTableData = async (tableName) => {

        const config = {
            headers: {
                userId: localStorage.getItem("userid"),
                "x-csrf-token": csrfToken,
            },
            withCredentials: true,
            params: {
                tableName,
                dataModel: "DEM",
            },
        };

        // Get JSON filename
        const apiResponse = await axios.post(previewrdmdata, {}, config);

        if (!apiResponse.data?.fileName) {
            throw new Error(`No data file available for ${tableName}`);
        }

        const fetchedFileName = apiResponse.data.fileName;

        // Fetch JSON
        const dataResponse = await fetch(`/jsonfiles/${fetchedFileName}`);

        if (!dataResponse.ok) {
            throw new Error(`Failed to load ${fetchedFileName}`);
        }

        const jsonData = await dataResponse.json();

        return {
            fileName: fetchedFileName,
            data: jsonData
        };
    };

    useEffect(() => {
        fetchStatusData();
    }, []);

    const fetchStatusData = async () => {
        const tableNameWithJson = "10192_residual.json";

        try {
            const response = await fetch(
                `/jsonfiles/${tableNameWithJson}`,
                { cache: "no-store" }
            );

            if (response.ok) {
                const data = await response.json();

                setStatusData(data);

                // Get reporting date from localStorage
                const reportDate = getStoredReportingDate();

                // Find status for current reporting date
                const currentStatus = data.find(
                    item => item.reporting_date === reportDate
                );

                // Get submitted remarks
                const submittedRemarks =
                    currentStatus?.uploadedtosama_remarks || "";

                setMakerRemarks(submittedRemarks);

                console.log("Reporting Date:", reportDate);
                console.log("Current Status:", currentStatus);
                console.log("Submitted Remarks:", submittedRemarks);

            } else {
                setStatusData([]);
                setMakerRemarks("");
            }

        } catch (err) {
            console.log(
                "No existing status file. Creating new one."
            );

            setStatusData([]);
            setMakerRemarks("");
        }
    };

    const sortQuarter = (a, b) => {

        const [qa, ya] = a.split("-");
        const [qb, yb] = b.split("-");

        const yearA = Number(ya);
        const yearB = Number(yb);

        if (yearA !== yearB) {
            return yearA - yearB;
        }

        return Number(qa.replace("Q", "")) - Number(qb.replace("Q", ""));
    };

    const fetchPreviewData = async (openReportingModal = true) => {
        try {

            const [tempResult, liveResult] = await Promise.all([
                fetchTableData("Risk_residual_credit_risk_temp"),
                fetchTableData("Risk_residual_credit_risk_live")
            ]);



            const tempRows = tempResult.data || [];

            setTempData(tempRows);
            setLiveData(liveResult.data || []);

            loadNextReportingDate(
                tempRows,
                liveResult.data || []
            );

            await loadExcel(tempRows);

            // Merge both tables
            const allRows = [...tempResult.data, ...liveResult.data];

            // Unique Reporting Dates
            const uniqueQuarters = [
                ...new Set(
                    allRows
                        .map(item => item.reporting_date)
                        .filter(date => date)
                        .map(date => getQuarterFromDate(date))
                )
            ].sort(sortQuarter);

            console.log("All unique quarters:", uniqueQuarters);

            const latestThreeReportingDates = uniqueQuarters.slice(-3);

            console.log("Latest 3 reporting dates:", latestThreeReportingDates);

            setReportingDates1(latestThreeReportingDates);

            if (latestThreeReportingDates.length > 0) {
                setselectedReportingDate1([]);
                setCapitalChargeData([]);
            }

            // Existing dropdown behaviour
            const storedDate = localStorage.getItem("selectedReportingDate");

            if (storedDate) {

                const quarter = reportingDates.find(
                    item => getReportingDate(item) === storedDate
                );

                if (quarter) {
                    // setReportingDate(quarter);   // Same as selecting from dropdown
                    setShowDownload(false);
                    setAllowSubmit(false);
                }

                localStorage.removeItem("selectedReportingDate");
            }

        } catch (err) {
            console.error("Preview Fetch Error:", err);
        }
    };

    const str = (c) => (c == null ? "" : String(c).trim());

    const isNullValue = (value) => {
        if (value == null) return true;

        const v = String(value).trim().toUpperCase();

        return (
            v === "" ||
            v === "\\N" ||
            v === "N" ||
            v === "//N" ||
            v === "NULL"
        );
    };
    const loadNextReportingDate = (temp, live) => {

        const usedDates = new Set();

        [...temp, ...live].forEach(row => {
            if (row.reporting_date) {
                usedDates.add(row.reporting_date);
            }
        });

        const nextQuarter = reportingDates.find(item => {
            const reportDate = getReportingDate(item);
            return !usedDates.has(reportDate);
        });

        if (nextQuarter) {
            setAvailableReportingDates([nextQuarter]);
            // setReportingDate(nextQuarter);   // <-- Important
        }

        setAvailableReportingDates(nextQuarter ? [nextQuarter] : []);
    };

    const reportingDates = [

        "Q2-2025",
        "Q3-2025",
        "Q4-2025",
        "Q1-2026",
        "Q2-2026",
        "Q3-2026",
        "Q4-2026"
    ];

    const handleCancel = () => {
        if (messageType === "success") {
            setIsEditMode(false);
            setMakerRemarks("");
            setIsViewMode(true);
        }

        setShowModal(false);
        setShowReportingModal1(false);
        setShowChargeModal(false);
        setModalMessage("");
    };

    const getQuarterFromReportingDate = (reportingDate) => {
        if (!reportingDate) return "";

        const [year, month, day] = reportingDate.split("-");

        switch (month) {
            case "03":
                return `Q1-${year}`;

            case "06":
                return `Q2-${year}`;

            case "09":
                return `Q3-${year}`;

            case "12":
                return `Q4-${year}`;

            default:
                return "";
        }
    };

    const handlePreviewOption = async () => {
        try {

            let arrayBuffer;


            const reportingDate =
                getStoredReportingDate();

            const quarter =
                getQuarterFromReportingDate(reportingDate);
            // =====================================================
            // USER HAS SELECTED AN EXCEL FILE
            // =====================================================

            if (selectedFile instanceof File) {

                console.log(
                    "Previewing selected file:",
                    selectedFile.name
                );

                arrayBuffer =
                    await selectedFile.arrayBuffer();

            } else {

                // =================================================
                // FETCH SERVER FILE
                // =================================================

                console.log(
                    "Fetching server Excel file..."
                );

                const fileName =
                    `Residual_Operational_Risk_${quarter}.xlsx`;

                const response = await fetch(
                    `/uploads/${fileName}`,
                    {
                        cache: "no-store"
                    }
                );

                if (!response.ok) {
                    throw new Error(
                        "Failed to fetch Residual_Operational_Risk.xlsx"
                    );
                }

                arrayBuffer =
                    await response.arrayBuffer();
            }

            // =====================================================
            // READ EXCEL
            // =====================================================

            const workbook = XLSX.read(arrayBuffer, {
                type: "array",
                cellStyles: true,
                cellNF: true,
                cellDates: true
            });

            const sheetName =
                "Residual Operational Risk";

            const worksheet =
                workbook.Sheets[sheetName];

            if (!worksheet) {
                throw new Error(
                    `Sheet "${sheetName}" not found`
                );
            }

            const tableRanges = [
                "B3:C6",
                "B8:J15",
                "B17:J22",
                "B26:E29",
                "B32:G33",
                "B40:I50",
                "B53:F63"
            ];

            const html = tableRanges
                .map(range =>
                    renderExcelTable(
                        worksheet,
                        range
                    )
                )
                .join("");

            setPreviewSheetData(html);
            setIsPreviewCompleted(true);
            setShowPreview(true);
            // setShowModal(true);

        } catch (error) {

            console.error(
                "Preview error:",
                error
            );

            setModalMessage(
                `Error previewing Residual_Operational_Risk.xlsx: ${error.message}`
            );

            setShowModal(true);
        }
    };

    const getCellStyle = (cell, cellAddress) => {
        const style = {};

        if (!cell) {
            return style;
        }

        const value =
            cell.v !== undefined && cell.v !== null
                ? String(cell.v).trim()
                : "";

        // ==========================================
        // DEFAULT EXCEL-LIKE STYLE
        // ==========================================
        style.fontFamily = "Calibri, Arial, sans-serif";
        style.fontSize = "11pt";
        style.verticalAlign = "middle";

        // ==========================================
        // MILD
        // ==========================================
        if (value.toLowerCase() === "mild") {
            style.backgroundColor = "#E5EDD3";
            style.fontWeight = "bold";
            style.textAlign = "center";
        }

        // ==========================================
        // MODERATE
        // ==========================================
        else if (value.toLowerCase() === "moderate") {
            style.backgroundColor = "#FFFFC9";
            style.fontWeight = "bold";
            style.textAlign = "center";
        }

        // ==========================================
        // SEVERE
        // ==========================================
        else if (value.toLowerCase() === "severe") {
            style.backgroundColor = "#FFD9DA";
            style.fontWeight = "bold";
            style.textAlign = "center";
        }

        // ==========================================
        // HELPER - CHECK EXCEL CELL RANGE
        // ==========================================
        const isCellInRange = (
            cellAddress,
            startAddress,
            endAddress
        ) => {
            if (!cellAddress) {
                return false;
            }

            const cellRef =
                XLSX.utils.decode_cell(cellAddress);

            const startRef =
                XLSX.utils.decode_cell(startAddress);

            const endRef =
                XLSX.utils.decode_cell(endAddress);

            return (
                cellRef.r >= startRef.r &&
                cellRef.r <= endRef.r &&
                cellRef.c >= startRef.c &&
                cellRef.c <= endRef.c
            );
        };

        // ==========================================
        // BCM HEADER
        // B40:I41
        // ==========================================
        if (
            isCellInRange(
                cellAddress,
                "B40",
                "I41"
            )
        ) {
            style.backgroundColor = "#FFFF00";
            style.fontWeight = "bold";
            style.textAlign = "center";
        }

        // ==========================================
        // BCM CALCULATION / RESULT CELLS
        // B42:I50
        // ==========================================
        if (
            isCellInRange(
                cellAddress,
                "B42",
                "I50"
            )
        ) {
            if (
                value !== "" &&
                !isNaN(Number(value))
            ) {
                style.backgroundColor = "#92D050";
            }
        }

        // ==========================================
        // FINAL CHARGE / RESULT AREA
        // B53:F63
        // ==========================================
        if (
            isCellInRange(
                cellAddress,
                "B53",
                "F63"
            )
        ) {
            if (
                value !== "" &&
                !isNaN(Number(value))
            ) {
                style.backgroundColor = "#FFFFCC";
            }
        }

        // ==========================================
        // EXCEL ALIGNMENT
        // ==========================================
        if (cell.s?.alignment) {
            if (cell.s.alignment.horizontal) {
                style.textAlign =
                    cell.s.alignment.horizontal;
            }

            if (cell.s.alignment.vertical) {
                style.verticalAlign =
                    cell.s.alignment.vertical;
            }

            if (cell.s.alignment.wrapText) {
                style.whiteSpace = "normal";
            }
        }

        // ==========================================
        // EXCEL FONT
        // ==========================================
        if (cell.s?.font) {
            if (cell.s.font.bold) {
                style.fontWeight = "bold";
            }

            if (cell.s.font.italic) {
                style.fontStyle = "italic";
            }

            if (cell.s.font.sz) {
                style.fontSize =
                    `${cell.s.font.sz}pt`;
            }
        }

        return style;
    };

    const styleObjectToString = (style) => {
        return Object.entries(style)
            .map(([key, value]) => {
                const cssKey = key.replace(
                    /[A-Z]/g,
                    match => `-${match.toLowerCase()}`
                );

                return `${cssKey}:${value}`;
            })
            .join(";");
    };


    const getMergedCellInfo = (
        worksheet,
        cellAddress
    ) => {
        const merges = worksheet["!merges"] || [];

        for (const merge of merges) {
            const start = XLSX.utils.encode_cell(
                merge.s
            );

            const end = XLSX.utils.encode_cell(
                merge.e
            );

            const range = XLSX.utils.decode_range(
                `${start}:${end}`
            );

            const target = XLSX.utils.decode_cell(
                cellAddress
            );

            if (
                target.r >= range.s.r &&
                target.r <= range.e.r &&
                target.c >= range.s.c &&
                target.c <= range.e.c
            ) {
                const isTopLeft =
                    target.r === range.s.r &&
                    target.c === range.s.c;

                return {
                    isMerged: true,
                    isTopLeft,
                    rowSpan:
                        range.e.r - range.s.r + 1,
                    colSpan:
                        range.e.c - range.s.c + 1
                };
            }
        }

        return {
            isMerged: false,
            isTopLeft: true,
            rowSpan: 1,
            colSpan: 1
        };
    };


    const escapeHtml = (value) => {
        return String(value)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
    };

    const renderExcelTable = (
        worksheet,
        rangeAddress
    ) => {
        const range =
            XLSX.utils.decode_range(rangeAddress);

        let html = `
        <div class="excel-table-section">
            <table class="excel-real-table">
                <tbody>
    `;

        /*
         * Track merged cells that are already rendered.
         */
        const skippedCells = new Set();

        for (
            let row = range.s.r;
            row <= range.e.r;
            row++
        ) {
            html += "<tr>";

            for (
                let col = range.s.c;
                col <= range.e.c;
                col++
            ) {
                const address =
                    XLSX.utils.encode_cell({
                        r: row,
                        c: col
                    });

                if (skippedCells.has(address)) {
                    continue;
                }

                const cell =
                    worksheet[address];

                const mergeInfo =
                    getMergedCellInfo(
                        worksheet,
                        address
                    );

                /*
                 * If this is part of a merged cell but
                 * isn't the top-left cell, don't render it.
                 */
                if (
                    mergeInfo.isMerged &&
                    !mergeInfo.isTopLeft
                ) {
                    continue;
                }

                /*
                 * Mark merged cells as already handled.
                 */
                if (mergeInfo.isMerged) {
                    const mergeStart =
                        XLSX.utils.decode_cell(address);

                    for (
                        let mr = mergeStart.r;
                        mr < mergeStart.r + mergeInfo.rowSpan;
                        mr++
                    ) {
                        for (
                            let mc = mergeStart.c;
                            mc < mergeStart.c + mergeInfo.colSpan;
                            mc++
                        ) {
                            const mergedAddress =
                                XLSX.utils.encode_cell({
                                    r: mr,
                                    c: mc
                                });

                            if (mergedAddress !== address) {
                                skippedCells.add(mergedAddress);
                            }
                        }
                    }
                }

                /*
                 * Excel value
                 */
                let value = "";

                if (cell) {
                    if (
                        cell.v !== undefined &&
                        cell.v !== null
                    ) {
                        value =
                            escapeHtml(
                                XLSX.utils.format_cell(
                                    cell
                                )
                            );
                    }
                }

                const style =
                    getCellStyle(cell, address);
                /*
                 * Give cells their actual Excel
                 * dimensions as much as possible.
                 */
                const columnWidth =
                    worksheet["!cols"]?.[col]?.wch;

                if (columnWidth) {
                    style.width =
                        `${Math.max(
                            columnWidth * 7,
                            35
                        )}px`;
                }

                const rowHeight =
                    worksheet["!rows"]?.[row]?.h;

                if (rowHeight) {
                    style.height =
                        `${rowHeight}px`;
                }

                html += `
                <td
                    ${mergeInfo.colSpan > 1
                        ? `colspan="${mergeInfo.colSpan}"`
                        : ""}
                    ${mergeInfo.rowSpan > 1
                        ? `rowspan="${mergeInfo.rowSpan}"`
                        : ""}
                    style="${styleObjectToString(
                            style
                        )}"
                >
                    ${value}
                </td>
            `;
            }

            html += "</tr>";
        }

        html += `
                </tbody>
            </table>
        </div>
    `;

        return html;
    };

    const handleCloseModal = () => {
        setShowPreview(false);
    }

    const handleCloseSuccessModal = () => {
        setShowModal(false);
        setIsPreviewCompleted(false);
        // Clear remarks
        setInputValue("");
        setInputValue1("");

        // Clear selected file
        setSelectedFile(null);

        // Clear preview
        setShowPreview(false);

        // Clear reporting date
        setSelectedReportingDate("");

        // Reset submission process
        setIsTemplateDownloaded(false);
        setIsFileUploaded(false);
        setIsConfirmed(false);
        setIsSubmitted(false);

        // Clear file input
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };

    const handleRemarksSubmit = async () => {
        try {
            setLoading(true);

            const userId = localStorage.getItem("userid");

            if (!userId) {
                throw new Error("User ID not found.");
            }

            const reportingDate = getStoredReportingDate();

            if (!reportingDate) {
                throw new Error("Reporting date is not available.");
            }

            await createStatusJson(
                reportingDate,
                "Data Uploaded to SAMA",
                "uploadtosama",
                inputValue1,
                "uploadedtosama_remarks"
            );

            setIsConfirmed(true);

            setIsSubmitted(true);

            setMessageType("success");

            setModalMessage(
                "Data Uploaded to SAMA Successfully"
            );

            SetshowMakerremarks(false);

            setShowModal(true);

            setInputValue("");

        } catch (error) {

            console.error(
                "Submit error:",
                error
            );

            setMessageType("error");

            setModalMessage(
                error.response?.data?.message ||
                error.message ||
                "Error while submitting data."
            );

            setShowModal(true);

        } finally {
            setLoading(false);
        }
    };

    const handleApproveSubmit = async () => {
        try {
            setLoading(true);

            const userId = localStorage.getItem("userid");

            if (!userId) {
                throw new Error("User ID not found.");
            }

            const reportingDate = getStoredReportingDate();

            if (!reportingDate) {
                throw new Error("Reporting date is not available.");
            }

            await createStatusJson(
                reportingDate,
                "Data Reinstated",
                "reinstate",
                inputValue1,
                "reinstated_remarks"
            );

            setIsConfirmed(true);

            setIsSubmitted(true);

            setMessageType("success");

            setModalMessage(
                "Data Reinstated Successfully"
            );

            SetshowMakerremarks1(false);

            setShowModal(true);

            setInputValue1("");

        } catch (error) {

            console.error(
                "Submit error:",
                error
            );

            setMessageType("error");

            setModalMessage(
                error.response?.data?.message ||
                error.message ||
                "Error while submitting data."
            );

            setShowModal(true);

        } finally {
            setLoading(false);
        }
    };


    const loadExcel = async (tempRows = []) => {
        try {
            const response = await fetch("/templates/sharaiah_template_sheet.xlsx");
            if (!response.ok) throw new Error("Unable to load Excel file.");

            const data = await response.arrayBuffer();
            // const workbook = XLSX.read(data, { type: "array" });
            const workbook = XLSX.read(data, {
                type: "array",
                cellText: true
            });
            const sheetName = "Shariah Risk (P 2) - Dec 25";
            const worksheet = workbook.Sheets[sheetName];
            if (!worksheet) { alert(`${sheetName} sheet not found`); return; }

            const rows = XLSX.utils.sheet_to_json(worksheet, {
                header: 1,
                defval: null,
                raw: true
            });

            // ── Helper: find the first row index where col1 matches a predicate ──
            const findRow = (predicate, from = 0) => {
                for (let i = from; i < rows.length; i++) {
                    const row = rows[i] || [];
                    if (predicate(row, i)) return i;
                }
                return -1;
            };

            const c1 = (row) => str(row[1]);

            // ── Locate landmark rows by content ──
            const iRow = findRow(r => r[0] === 1 && c1(r).toLowerCase().includes("name of risk"));
            const iSec2 = findRow(r => r[0] === 2);
            const iDefLabel = findRow(r => c1(r).toLowerCase().startsWith("definition"));
            const iSec3 = findRow(r => r[0] === 3 && c1(r).toLowerCase().includes("key areas"));
            const iSec4 = findRow(r => r[0] === 4 && c1(r).toLowerCase().includes("risk measurement"));
            const iIntro = findRow(r => c1(r).toLowerCase().includes("keeping in view"), iSec4);
            const iTableTitle = findRow(r => c1(r).toLowerCase().includes("computation of shariah"), iSec4);
            const iPeriod = findRow(r => c1(r).toLowerCase().startsWith("period"), iSec4);
            const iIdxHdr = findRow(r => c1(r).toLowerCase() === "key areas" && r[0] === null, iTableTitle);
            // const iTotalRow = findRow(r => (r[1] === null || r[1] === undefined || str(r[1]) === "") && typeof r[2] === "number", iIdxHdr + 1);
            const iTotalRow = findRow(
                r => {
                    const label = str(r[1]).toLowerCase();

                    return (
                        label.includes("total") ||
                        (label === "" && typeof r[2] === "number")
                    );
                },
                iIdxHdr + 1
            );
            const iGradeHdr = findRow(r => c1(r).toLowerCase() === "score grade", iTotalRow);
            const iPartHdr = findRow(r => c1(r).toLowerCase() === "particulars", iGradeHdr);
            const iQuarterHdr = findRow(r => [r[1], r[2], r[3], r[4]].some(c => /^Q\d-\d{4}$/i.test(str(c))), iPartHdr);
            const iQuarterVal = findRow(r => [r[1], r[2], r[3], r[4]].every(c => typeof c === "number"), iQuarterHdr + 1);
            const iFinalCap = findRow(r => c1(r).toLowerCase().includes("final capital charge"), iQuarterVal);

            // ── Extract each section ──

            // 1. Name of risk
            const rowNameOfRisk = rows[iRow] || [];
            const nameOfRisk = str(rowNameOfRisk[3]) || str(rowNameOfRisk[2]) || "";

            // 2. Summary
            const summary = iSec2 >= 0 ? c1(rows[iSec2]) : "";

            // 3. Definition
            const definition = iDefLabel >= 0 ? c1(rows[iDefLabel]) : "";
            const defTextRow = iDefLabel >= 0 ? findRow(r => c1(r).length > 10, iDefLabel + 1) : -1;
            const definitionText = defTextRow >= 0 ? c1(rows[defTextRow]) : "";

            // 4. Pillar
            const iPillar = findRow(r => c1(r).toUpperCase().includes("PILLAR"));
            const pillar = iPillar >= 0 ? c1(rows[iPillar]) : "";

            // 5. Key areas
            const keyAreasIntroRow = findRow(r => c1(r).toLowerCase().includes("the bank considers"), iSec3);
            const keyAreasIntro = keyAreasIntroRow >= 0 ? c1(rows[keyAreasIntroRow]) : "";
            const keyAreas = [];
            const keyEnd = iSec4 >= 0 ? iSec4 : rows.length;
            for (let i = (keyAreasIntroRow >= 0 ? keyAreasIntroRow + 1 : iSec3 + 1); i < keyEnd; i++) {
                const txt = c1(rows[i]);
                if (txt.length > 10) keyAreas.push(txt);
            }

            // 6. Risk measurement
            const heading = iSec4 >= 0 ? c1(rows[iSec4]) : "";
            const intro = iIntro >= 0 ? c1(rows[iIntro]) : "";
            const tableTitle = iTableTitle >= 0 ? c1(rows[iTableTitle]) : "";
            const period = iPeriod >= 0 ? c1(rows[iPeriod]) : "";

            // Index table headers (cols 1,2,3,5,7 — skip merged empty cols)
            const indexHeaders = iIdxHdr >= 0
                ? [rows[iIdxHdr][1], rows[iIdxHdr][2], rows[iIdxHdr][3], rows[iIdxHdr][5], rows[iIdxHdr][7]]
                    .map(h => str(h).replace(/\n/g, " "))
                : [];

            // setIndexRows(indexRows);
            const parsedIndexRows = [];

            if (iIdxHdr >= 0 && iTotalRow >= 0) {
                for (let i = iIdxHdr + 1; i < iTotalRow; i++) {

                    const r = rows[i];

                    if (c1(r).length > 0) {

                        const keyArea = str(r[1]);

                        const tempRow = tempRows.find(
                            item =>
                                str(item.key_areas).trim().toLowerCase() ===
                                keyArea.trim().toLowerCase()
                        );

                        parsedIndexRows.push({
                            keyArea: tempRow?.key_areas || keyArea,

                            weight: tempRow?.weight_a || "0%",

                            observations:
                                tempRow?.no_of_observations_issues_non_compliance_delays_self_assesment_b === "\\N"
                                    ? ""
                                    : tempRow?.no_of_observations_issues_non_compliance_delays_self_assesment_b || 0,

                            impact:
                                tempRow?.impact_scale_of_1_to_10_c === "\\N"
                                    ? ""
                                    : tempRow?.impact_scale_of_1_to_10_c || "",

                            index: tempRow?.index_a_b_c
                                ? Number(tempRow.index_a_b_c)
                                : 0
                        });
                    }
                }
            }

            setIndexRows(parsedIndexRows);
            setInitialIndexRows(parsedIndexRows.map(row => ({ ...row })));
            // Index table data rows (between header and total row)
            const indexRows = [];
            if (iIdxHdr >= 0 && iTotalRow >= 0) {
                for (let i = iIdxHdr + 1; i < iTotalRow; i++) {
                    const r = rows[i];
                    if (c1(r).length > 0) {
                        // indexRows.push([str(r[1]), r[2], r[3], r[5], r[7]]);
                        indexRows.push({
                            keyArea: str(r[1]),
                            weight: Number(r[2]) || 0,   // A
                            observations: "",            // B (editable)
                            impact: "",                  // C (editable)
                            index: 0                     // A * B * C
                        });
                    }
                }
            }

            // Index total row
            const indexTotal = iTotalRow >= 0
                ? { weight: rows[iTotalRow][2], index: rows[iTotalRow][7] }
                : null;

            // Grade table headers (cols 1,2,3,4,6 — skip merged col 5)
            const gradeHeaders = iGradeHdr >= 0
                ? [rows[iGradeHdr][1], rows[iGradeHdr][2], rows[iGradeHdr][3], rows[iGradeHdr][4], rows[iGradeHdr][6]]
                    .map(h => str(h))
                : [];

            // Grade rows (between grade header and particulars header)
            const parsedGradeRows = [];

            const uniqueGrades = [
                ...new Map(
                    tempRows
                        .filter(row =>
                            row.score_grade &&
                            row.score_grade !== "\\N"
                        )
                        .map(row => [
                            row.score_grade,
                            row
                        ])
                ).values()
            ];

            uniqueGrades.forEach(tempRow => {

                parsedGradeRows.push({
                    scoreGrade: tempRow.score_grade,

                    min:
                        tempRow.min === "\\N"
                            ? 0
                            : Number(tempRow.min) || 0,

                    max:
                        tempRow.max === "\\N"
                            ? 0
                            : Number(tempRow.max) || 0,

                    percentage:
                        tempRow.percentage_of_operational_risk_pillar_i_capital_charge === "\\N"
                            ? "0%"
                            : tempRow.percentage_of_operational_risk_pillar_i_capital_charge || "0%",

                    applicablePercentage:
                        tempRow.applicable_percentage === "\\N"
                            ? "0%"
                            : tempRow.applicable_percentage || "0%"
                });
            });

            setGradeRows(parsedGradeRows);

            setInitialGradeRows(
                parsedGradeRows.map(row => ({ ...row }))
            );

            // Particulars rows (between particulars header and quarter header)
            // Particulars rows (between particulars header and quarter header)
            const particularsRows = [];

            if (iPartHdr >= 0 && iQuarterHdr >= 0) {
                for (let i = iPartHdr + 1; i < iQuarterHdr; i++) {

                    const r = rows[i];

                    if (c1(r).length > 0) {

                        const label = c1(r);

                        // Fetch amount from DB tempRows instead of Excel
                        const tempRow = tempRows.find(
                            item =>
                                str(item.particulars).trim().toLowerCase() ===
                                label.trim().toLowerCase()
                        );

                        let amount = tempRow?.amount;

                        // Convert 0.15 -> 15%
                        if (amount !== undefined && amount !== null && amount !== "\\N") {
                            const numericAmount = Number(amount);

                            if (!isNaN(numericAmount)) {
                                amount = `${numericAmount * 100}%`;
                            }
                        } else {
                            amount = "";
                        }

                        particularsRows.push({
                            label: tempRow?.particulars || label,
                            amount
                        });
                    }
                }
            }

            // Quarter headers and values
            const quarterHeaders = iQuarterHdr >= 0
                ? [rows[iQuarterHdr][1], rows[iQuarterHdr][2], rows[iQuarterHdr][3], rows[iQuarterHdr][4]].map(str)
                : [];
            const quarterValues = iQuarterVal >= 0
                ? [rows[iQuarterVal][1], rows[iQuarterVal][2], rows[iQuarterVal][3], rows[iQuarterVal][4]]
                : [];

            // Final capital charge
            const finalCapital = iFinalCap >= 0
                ? { label: c1(rows[iFinalCap]), val: rows[iFinalCap][5] }
                : null;

            setSheetData({
                pillar,
                nameOfRisk,
                summary,
                definition,
                definitionText,
                keyAreasIntro,
                keyAreas,
                riskMeasurement: {
                    heading,
                    intro,
                    tableTitle,
                    period,
                    indexHeaders,
                    indexRows: parsedIndexRows,
                    indexTotal,
                    gradeHeaders,
                    gradeRows: parsedGradeRows,
                    particularsRows,
                    quarterHeaders,
                    quarterValues,
                    finalCapital
                },
            });

            setExcelLoaded(true);

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
            setExcelLoaded(true);
        }
    };

    const restoreExcelValues = () => {
        setIndexRows(initialIndexRows.map(row => ({ ...row })));
        setGradeRows(initialGradeRows.map(row => ({ ...row })));
    };

    const totalWeight = indexRows.reduce(
        (sum, row) =>
            sum +
            (parseFloat(String(row.weight || "0").replace("%", "")) / 100),
        0
    );

    const totalIndex = indexRows.reduce(
        (sum, row) => sum + (Number(row.index) || 0),
        0
    );

    const calculatedGradeRows = gradeRows
        .filter(row =>
            row.scoreGrade &&
            row.scoreGrade !== "\\N"
        )
        .map((row) => ({
            ...row,

            applicablePercentage:
                totalIndex >= Number(row.min) &&
                    totalIndex <= Number(row.max)
                    ? row.applicablePercentage
                    : "0.00%"
        }));

    const totalApplicablePercentage = calculatedGradeRows.reduce(
        (sum, row) => {
            const percentage =
                parseFloat(
                    String(row.applicablePercentage || "0").replace("%", "")
                ) / 100;

            return sum + percentage;
        },
        0
    );

    const capitalChargeForShariahRisk = Math.round(
        (Number(operationalRiskCharge) || 0) * totalApplicablePercentage
    );

    const getQuarterSequence = (selectedQuarter) => {
        if (!selectedQuarter) return [];

        const [q, yearStr] = selectedQuarter.split("-");
        const year = Number(yearStr);
        const quarter = Number(q.replace("Q", ""));

        const quarters = [];

        for (let i = 3; i >= 0; i--) {
            let currentQuarter = quarter - i;
            let currentYear = year;

            while (currentQuarter <= 0) {
                currentQuarter += 4;
                currentYear--;
            }

            quarters.push(`Q${currentQuarter}-${currentYear}`);
        }

        return quarters;
    };


    const getQuarterFromDate = (date) => {
        const d = new Date(date);

        const year = d.getFullYear();
        const month = d.getMonth() + 1;

        if (month <= 3) return `Q1-${year}`;
        if (month <= 6) return `Q2-${year}`;
        if (month <= 9) return `Q3-${year}`;
        return `Q4-${year}`;
    };

    const dataMap = {};

    liveData.forEach(item => {
        const quarter = getQuarterFromDate(item.reporting_date);

        dataMap[`${item.key_areas}_${quarter}`] = item;
    });

    const getQuarterValues = (selectedQuarter, keyArea) => {

        const quarters = getQuarterSequence(selectedQuarter);

        return quarters.map(q => {

            const record = dataMap[`${keyArea}_${q}`];

            return record
                ? record.final_capital_charge_for_quarter4_average_of_4_quarters
                : "";
        });

    };

    const values = getQuarterValues(reportingDate, "Shariah Committee Matters");

    const q4 = capitalChargeForShariahRisk;

    const finalCapitalCharge = Math.round(
        (
            (Number(values[0]) || 0) +
            (Number(values[1]) || 0) +
            (Number(values[2]) || 0) +
            (Number(q4) || 0)
        ) / 4
    );

    const formatPercent = (value) => {
        if (value === "" || value == null) return "0.00%";

        return `${(Number(value) * 100).toFixed(0)}%`;
    };

    const formatExcelPercent = (value) => {
        if (value === "" || value == null || value === "\\N") {
            return "0%";
        }

        // DB value already contains %
        if (String(value).includes("%")) {
            return String(value);
        }

        // Excel decimal value
        const number = Number(value);

        if (isNaN(number)) {
            return "0%";
        }

        return `${(number * 100).toFixed(0)}%`;
    };

    const formatApplicablePercent = (value) => {
        if (value === "" || value == null || value === "\\N") {
            return "0.00%";
        }

        // DB already returns percentage format like "0.00%"
        if (String(value).includes("%")) {
            return String(value);
        }

        // For decimal values like 0.03 -> 3.00%
        const number = Number(value);

        if (isNaN(number)) {
            return "0.00%";
        }

        return `${(number * 100).toFixed(2)}%`;
    };

    const formatNumber = (value) => {
        if (value === "\\N" || value === null || value === undefined || value === "") {
            return "";
        }

        const number = Number(value);

        if (isNaN(number)) {
            return value;
        }

        return number.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    };

    const handleReset = () => {
        setOperationalRiskCharge("");
        setQ1("");
        setQ2("");
        setQ3("");

        const resetRows = indexRows.map(row => ({
            ...row,
            observations: "",
            impact: "",
            index: 0
        }));

        setIndexRows(resetRows);
    };

    const getReportingDate = (quarter) => {
        if (!quarter) return "";

        const [q, year] = quarter.split("-");

        switch (q) {
            case "Q1":
                return `${year}-03-31`;
            case "Q2":
                return `${year}-06-30`;
            case "Q3":
                return `${year}-09-30`;
            case "Q4":
                return `${year}-12-31`;
            default:
                return "";
        }
    };

    const generateTxtData = () => {
        const reportDate = getReportingDate(reportingDate);

        const lines = [];

        const particulars = sheetData.riskMeasurement.particularsRows;

        for (let i = 0; i < indexRows.length; i++) {

            const idx = indexRows[i];
            const grade = calculatedGradeRows[i] || {};

            let particularLabel = "";
            let particularValue = "";

            let quarter1 = "\\N";
            let quarter2 = "\\N";
            let quarter3 = "\\N";
            let quarter4 = "\\N";
            let average = "\\N";

            // First three Particular rows only
            if (i === 0) {
                particularLabel = particulars[0]?.label || "";
                particularValue = operationalRiskCharge;

                quarter1 = q1 || "\\N";
                quarter2 = q2 || "\\N";
                quarter3 = q3 || "\\N";
                quarter4 = q4 || "\\N";
                average = finalCapitalCharge || "\\N";
            }
            else if (i === 1) {
                particularLabel = particulars[1]?.label || "";
                particularValue = formatApplicablePercent(totalApplicablePercentage);
            }
            else if (i === 2) {
                particularLabel = particulars[2]?.label || "";
                particularValue = capitalChargeForShariahRisk;
            }

            lines.push([
                reportDate,
                idx.keyArea,
                formatPercent(idx.weight),
                idx.observations || "",
                idx.impact || "",
                Number(idx.index).toFixed(2),
                grade.scoreGrade || "",
                grade.min ?? "\\N",
                grade.max ?? "\\N",
                grade.percentage ? formatExcelPercent(grade.percentage) : "",
                formatApplicablePercent(grade.applicablePercentage),
                particularLabel,
                particularValue,
                quarter1,
                quarter2,
                quarter3,
                quarter4,
                average
            ].join("|"));
        }

        // Total Row
        lines.push([
            reportDate,
            "",
            formatPercent(totalWeight),
            "",
            "",
            Number(totalIndex).toFixed(2),
            "",
            "\\N",
            "\\N",
            "",
            "",
            "",
            "",
            "\\N",
            "\\N",
            "\\N",
            "\\N",
            "\\N"
        ].join("|"));

        return lines.join("\n");
    };

    const handleCloseReportingModal = () => {
        setselectedReportingDate1([]);
        setShowReportingModal(false);
    };

    const handleReportingDateSubmit = () => {

        const mergedData = [...liveData, ...tempData];

        const filteredData = mergedData.filter(item =>
            selectedReportingDate1.includes(
                getQuarterFromDate(item.reporting_date)
            )
        );

        const result = selectedReportingDate1
            .map(reportingDate => {

                const dateRows = filteredData.filter(
                    item =>
                        getQuarterFromDate(item.reporting_date) === reportingDate
                );

                if (dateRows.length === 0) {
                    return null;
                }

                const capitalChargeRow = dateRows.find(
                    item =>
                        item.final_capital_charge_for_quarter4_average_of_4_quarters &&
                        item.final_capital_charge_for_quarter4_average_of_4_quarters !== "\\N"
                );

                const rows = dateRows
                    .filter(item => item.key_areas)
                    .map(item => ({
                        key_areas:
                            item.key_areas === "\\N"
                                ? ""
                                : item.key_areas,

                        weight_a:
                            item.weight_a === "\\N"
                                ? ""
                                : item.weight_a,

                        observations:
                            item.no_of_observations_issues_non_compliance_delays_self_assesment_b === "\\N"
                                ? ""
                                : item.no_of_observations_issues_non_compliance_delays_self_assesment_b,

                        impact:
                            item.impact_scale_of_1_to_10_c === "\\N"
                                ? ""
                                : item.impact_scale_of_1_to_10_c
                    }));

                return {
                    reportingDate: reportingDate,

                    capitalCharge: capitalChargeRow
                        ? capitalChargeRow.final_capital_charge_for_quarter4_average_of_4_quarters
                        : "",

                    rows: rows
                };

            })
            .filter(Boolean);

        setCapitalChargeData(result);
    };

    const rejectColumns = [
        {
            value: "Total No of Outstanding Legal Cases",
            label: "Total No of Outstanding Legal Cases"
        },
        {
            value: "Provision held against Legal cases (SR)",
            label: "Provision held against Legal cases (SR)"
        },
        {
            value: "No. of Legal cases against which Provision is held",
            label: "No. of Legal cases against which Provision is held"
        },
        {
            value: "Average Provision Amount per case (SR)",
            label: "Average Provision Amount per case (SR)"
        },
        {
            value: "No of Un-provided Legal Cases",
            label: "No of Un-provided Legal Cases"
        },
        {
            value: "Cumulative % of cases lost over past five years (estimate)",
            label: "Cumulative % of cases lost over past five years (estimate)"
        },
        {
            value: "Max Potential Un-provided Exposure (SR)",
            label: "Max Potential Un-provided Exposure (SR)"
        },
        {
            value: "Capital Allocation (SR)",
            label: "Capital Allocation (SR)"
        }
    ];

    const handleColumnSelect = (e) => {

        setSelectedColumn(e.target.value);

        if (e.target.value !== "Others") {
            setOtherReason("");
        }
    };

    const handleOtherReasonChange = (e) => {
        setOtherReason(e.target.value);
    };

    const formatColumnLabel = (column) => {

        return column
            .replace(/_/g, " ")
            .replace(/\b\w/g, c => c.toUpperCase());

    };

    const isReasonRequired = selectedColumn === "Others";

    const isSubmitDisabled =
        !selectedColumn ||
        (isReasonRequired && !otherReason.trim());

    const handleReasonSubmit = () => {

        if (!selectedColumn) {

            setMessageType("warning");
            setModalMessage("Please select rejection reason.");
            setShowModal(true);

            return;
        }

        if (selectedColumn === "Others" && !otherReason.trim()) {

            setMessageType("warning");
            setModalMessage("Please enter rejection reason.");
            setShowModal(true);

            return;
        }

        let reason = "";

        if (selectedColumn === "DeleteRecord") {

            reason = otherReason.trim()
                ? otherReason.trim()
                : "Delete the record";

        }
        else if (selectedColumn === "Others") {

            reason = otherReason.trim();

        }
        else {

            reason = otherReason.trim()
                ? `${formatColumnLabel(selectedColumn)} is not correct : ${otherReason}`
                : `${formatColumnLabel(selectedColumn)} is not correct`;

        }

        setRejectedReason(reason);

        setShowRejectModal(false);

        callRejectApi(reason);

    };

    const createStatusJson = async (
        reportingDate,
        status,
        fileType,
        approvedRemarks = "",
        actualValueFlag = "N"
    ) => {

        const today = new Date().toISOString().split("T")[0];
        const userId = localStorage.getItem("userid");

        const tableNameWithJson =
            `10192_residual.json`;

        let statusData = [];

        try {
            const response = await fetch(`/jsonfiles/${tableNameWithJson}`);

            if (response.ok) {
                statusData = await response.json();
            }
        } catch (err) {
            console.log("No existing status file. Creating new one.");
        }

        const newStatus = {
            reporting_date: reportingDate,
            submitted_date: today,
            status,
            reported_by: "10192",
            reviewed_by: "10007",
            Overridden_by: "10034",
            tableName: "Residual_Operational_Risk"

        };

        if (approvedRemarks) {
            newStatus.approved_remarks = approvedRemarks;
        }

        // Remove only the same reporting date
        const index = statusData.findIndex(
            item => item.reporting_date === reportingDate
        );

        if (index !== -1) {
            statusData.splice(index, 1);
        }

        // Latest entry always first
        statusData.unshift(newStatus);

        const updateResponse = await axios.post(
            updatetextfile3001,
            {
                tableNameWithJson,
                content: JSON.stringify(statusData, null, 2)
            },
            {
                headers: {
                    userId,
                    "x-csrf-token": csrfToken
                },
                withCredentials: true
            }
        );

        if (updateResponse.status === 200) {
            const fileName = "10192_residual.json";
            const filePath = `/saswork/nas/${fileName}`;

            const config = {
                headers: {
                    userId: localStorage.getItem("userid"),
                    "x-csrf-token": csrfToken,
                },
                withCredentials: true,
                params: {
                    dept: department,
                    Notifications: "IN",
                    filePath: filePath
                }
            };

            try {
                const response = await axios.post(
                    shariahremarks,
                    {},
                    config
                );

                console.log("Shariah Remarks API Response:", response.data);

            } catch (err) {
                console.error("Shariah Remarks API Error:", err);
            }
        }

        console.log(`${tableNameWithJson} updated successfully`);
    };


    const callRejectApi = async (reason) => {

        try {

            setLoading(true);

            // =====================================================
            // REPORTING DATE FROM LOCAL STORAGE
            // =====================================================

            const reportDate =
                getStoredReportingDate();

            if (!reportDate) {

                throw new Error(
                    "Reporting date is not available."
                );
            }

            console.log(
                "Reject Reporting Date:",
                reportDate
            );

            console.log(
                "Reject Reason:",
                reason
            );

            // =====================================================
            // CREATE STATUS JSON
            // NO checkboxreject API
            // =====================================================

            await createStatusJson(
                reportDate,
                "Pending for Maker Modification",
                "reject",
                reason
            );

            setIsConfirmed(true);
            setIsSubmitted(true);
            // =====================================================
            // SUCCESS
            // =====================================================

            setMessageType("success");

            setModalMessage(
                "Data Rejected Successfully"
            );

            // =====================================================
            // REFRESH DATA
            // =====================================================

            await fetchPreviewData();

            setMakerRemarks("");

            handleReset();

            setIsViewMode(false);

            setShowDownload(false);

            setRejectedReason("");

            setSelectedColumn("");

            setOtherReason("");

            setShowModal(true);

        } catch (error) {

            console.error(
                "Reject error:",
                error
            );

            setMessageType("error");

            setModalMessage(
                error.response?.data?.message ||
                error.message ||
                "Error while rejecting."
            );

            setShowModal(true);

        } finally {

            setLoading(false);
        }
    };

    const handleBulkApprove = async () => {

        setShowConfirmApprove(false);

        const reportDate = getReportingDate(reportingDate);

        const selectedRecords = tempData.filter(
            row => row.reporting_date === reportDate
        );

        const rowIds = selectedRecords.map(row => row.rowId);

        try {

            const config = {
                headers: {
                    userId: localStorage.getItem("userid"),
                    "x-csrf-token": csrfToken,
                },
                withCredentials: true,
                params: {
                    tableName: "residual_credit_risk",
                    status: 1,
                    dataModel: "BDM",
                    Notifications: "IN",
                    isBulk: 1,
                    dept: department,
                },
            };

            const response = await axios.post(
                checkboxapprove,   // <-- Bulk approve checkbox API
                rowIds,            // <-- Send row IDs in request body
                config
            );

            console.log(response.data);

            if (response.data?.message === "Data Approved") {

                setMessageType("success");
                setModalMessage("Data Approved Successfully");

                await createStatusJson(
                    reportDate,
                    "Data Approved",
                    "approve",
                    inputValue
                );
                await fetchPreviewData();
                SetshowMakerremarks(false);

                setShowDownload(true);   // <-- Show Download button
                setShowActionButtons(false);


            } else {

                setMessageType("error");
                setModalMessage(response.data.message || "Approval Failed");

            }

            setShowModal(true);

        } catch (error) {

            console.log(error);

            setMessageType("error");
            setModalMessage(
                error.response?.data?.message ||
                "Error while approving."
            );

            setShowModal(true);
        }
    };

    // const handleUploadedtoSama = async () => {

    //     setShowConfirmApprove(false);

    //     // const reportDate = getReportingDate(reportingDate);

    //       const userId = localStorage.getItem("userid");

    //         if (!userId) {
    //             throw new Error("User ID not found.");
    //         }

    //         const reportingDate = getStoredReportingDate();

    //         if (!reportingDate) {
    //             throw new Error("Reporting date is not available.");
    //         }


    //     try {

    //         const config = {
    //             headers: {
    //                 userId: localStorage.getItem("userid"),
    //                 "x-csrf-token": csrfToken,
    //             },
    //             withCredentials: true,
    //             params: {
    //                 userId: localStorage.getItem("userid"),
    //                 dept: department,
    //                 tableName: "Risk_residual_credit_risk",
    //                 reportingDate: reportingDate,
    //                 p_active_yn: "Y",
    //                 p_live_table_yn: "Y"
    //             },
    //         };

    //         const response = await axios.post(
    //             updateshariahoverride,
    //             {},          // No request body
    //             config
    //         );

    //         console.log(response.data);

    //         if (response.data?.status === "SUCCESS") {

    //             setMessageType("success");
    //             setModalMessage("Data Overridden Successfully");

    //             // const actualValueFlag = getActualValueFlag(reportDate);

    //             await createStatusJson(
    //                 reportingDate,
    //                 "Data Overridden",
    //                 "approve",
    //                 inputValue,
    //                 // actualValueFlag
    //             );

    //             await fetchPreviewData();
    //             SetshowMakerremarks(false);

    //         } else {

    //             setMessageType("error");
    //             setModalMessage(response.data.message || "Approval Failed");
    //         }

    //         setShowModal(true);

    //     } catch (error) {

    //         console.error(error);

    //         setMessageType("error");
    //         setModalMessage(
    //             error.response?.data?.message ||
    //             "Error while approving."
    //         );

    //         setShowModal(true);
    //     }
    // };

    const handleUploadedtoSama = async () => {

        setShowConfirmApprove(false);

        const userId = localStorage.getItem("userid");

        if (!userId) {
            throw new Error("User ID not found.");
        }

        const reportingDate = getStoredReportingDate();

        if (!reportingDate) {
            throw new Error("Reporting date is not available.");
        }

        try {

            setMessageType("success");
            setModalMessage("Data Overridden Successfully");

            await createStatusJson(
                reportingDate,
                "Data Overridden",
                "approve",
                inputValue
            );

            await fetchPreviewData();
            SetshowMakerremarks(false);

            setShowModal(true);

        } catch (error) {

            console.error(error);

            setMessageType("error");
            setModalMessage(
                error.response?.data?.message ||
                "Error while approving."
            );

            setShowModal(true);
        }
    };

    const handleCloseMakerPOP = () => {
        SetshowMakerremarks(false);
    };

    const getFinalCapitalLabel = (selectedQuarter) => {
        if (!selectedQuarter)
            return "Final Capital Charge (Average of 4 Quarters)";

        const [q, year] = selectedQuarter.split("-");

        const quarterEndDates = {
            Q1: `31-MAR-${year}`,
            Q2: `30-JUN-${year}`,
            Q3: `30-SEP-${year}`,
            Q4: `31-DEC-${year}`
        };

        return `Final Capital Charge for ${quarterEndDates[q]} (Average of 4 Quarters)`;
    };

    const handleDownload = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Shariah Risk");

        // -----------------------------
        // Styles
        // -----------------------------
        const headerStyle = {
            font: {
                bold: true,
                color: { argb: "FFFFFFFF" },
            },
            fill: {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "1F4E78" },
            },
            alignment: {
                horizontal: "center",
                vertical: "middle",
                wrapText: true,
            },
            border: {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
            },
        };

        const borderStyle = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
        };

        const totalStyle = {
            font: {
                bold: true,
            },
            fill: {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "D9D9D9" },
            },
            border: borderStyle,
        };

        // -----------------------------
        // Column Widths
        // -----------------------------
        worksheet.columns = [
            { width: 40 },
            { width: 18 },
            { width: 22 },
            { width: 18 },
            { width: 22 },
        ];

        // -----------------------------
        // Title
        // -----------------------------
        worksheet.mergeCells("A1:E1");

        const title = worksheet.getCell("A1");
        title.value = "Shariah Risk Measurement";
        title.font = {
            bold: true,
            size: 16,
        };
        title.alignment = {
            horizontal: "center",
        };

        worksheet.addRow([]);

        worksheet.addRow(["Reporting Date", reportingDate]);

        worksheet.addRow([]);

        // ===================================================
        // STATIC INFORMATION
        // ===================================================

        // 1. Name of Risk
        if (sheetData.nameOfRisk) {
            let row = worksheet.addRow(["1. Name of Risk"]);
            row.getCell(1).font = { bold: true, color: { argb: "1F4E78" } };

            row = worksheet.addRow([sheetData.nameOfRisk]);
            worksheet.addRow([]);
        }

        // 2. Summary
        if (sheetData.summary) {

            // Heading
            let row = worksheet.addRow(["2. Summary"]);
            row.getCell(1).font = {
                bold: true,
                color: { argb: "1F4E78" }
            };

            // Summary text
            row = worksheet.addRow([sheetData.summary]);

            worksheet.mergeCells(`A${row.number}:E${row.number}`);
            console.log(worksheet.getCell(`A${row.number}`).isMerged);

            row.getCell(1).alignment = {
                wrapText: true,
                horizontal: "left",
                vertical: "top",
            };

            worksheet.addRow([]);
        }

        // 3. Definition
        if (sheetData.definition) {

            // Heading
            let row = worksheet.addRow([sheetData.definition]);
            row.getCell(1).font = {
                bold: true,
                color: { argb: "1F4E78" },
            };

            // Definition text
            row = worksheet.addRow([sheetData.definitionText]);

            // Merge across all columns
            worksheet.mergeCells(`A${row.number}:E${row.number}`);

            row.getCell(1).alignment = {
                wrapText: true,
                vertical: "top",
                horizontal: "left",
            };

            worksheet.addRow([]);
        }

        // 4. Key Areas of Risk
        if (sheetData.keyAreas.length > 0) {

            // Heading
            let row = worksheet.addRow(["3. Key Areas of Risk"]);
            row.getCell(1).font = {
                bold: true,
                color: { argb: "1F4E78" },
            };

            // Intro
            if (sheetData.keyAreasIntro) {
                row = worksheet.addRow([sheetData.keyAreasIntro]);

                worksheet.mergeCells(`A${row.number}:E${row.number}`);

                row.getCell(1).alignment = {
                    wrapText: true,
                    vertical: "top",
                    horizontal: "left",
                };
            }

            // Bullet points
            sheetData.keyAreas.forEach((area) => {

                const text =
                    typeof area === "string"
                        ? area
                        : JSON.stringify(area);

                const bulletRow = worksheet.addRow([`• ${text}`]);

                worksheet.mergeCells(`A${bulletRow.number}:E${bulletRow.number}`);

                bulletRow.getCell(1).alignment = {
                    wrapText: true,
                    vertical: "top",
                    horizontal: "left",
                };
            });

            worksheet.addRow([]);
        }

        // 5. Risk Measurement
        // 5. Risk Measurement
        if (sheetData.riskMeasurement.heading) {

            // Heading
            let row = worksheet.addRow([
                `4. ${sheetData.riskMeasurement.heading}`,
            ]);

            row.getCell(1).font = {
                bold: true,
                color: { argb: "1F4E78" },
            };

            // Intro
            if (sheetData.riskMeasurement.intro) {
                row = worksheet.addRow([
                    sheetData.riskMeasurement.intro,
                ]);

                // Merge across all columns
                worksheet.mergeCells(`A${row.number}:E${row.number}`);

                row.getCell(1).alignment = {
                    wrapText: true,
                    vertical: "top",
                    horizontal: "left",
                };
            }

            worksheet.addRow([]);
        }

        // ===================================================
        // TABLE 1
        // ===================================================

        const header1 = worksheet.addRow([
            "Key Area",
            "Weight (A)",
            "No. of Observations (B)",
            "Impact (C)",
            "Shariah Risk Index",
        ]);

        header1.eachCell((cell) => {
            Object.assign(cell, {
                style: headerStyle,
            });
        });

        indexRows.forEach((r) => {
            const row = worksheet.addRow([
                r.keyArea,
                Number(r.weight),
                Number(r.observations),
                Number(r.impact),
                r.index,
            ]);

            // Format Weight column as percentage
            row.getCell(2).numFmt = "0.00%";

            row.eachCell((cell) => {
                cell.border = borderStyle;
            });
        });

        const totalRow = worksheet.addRow([
            "",
            Number(totalWeight),
            "",
            "",
            totalIndex,
        ]);

        // Format Total Weight as percentage
        totalRow.getCell(2).numFmt = "0.00%";

        totalRow.eachCell((cell) => {
            cell.font = totalStyle.font;
            cell.fill = totalStyle.fill;
            cell.border = totalStyle.border;
        });

        totalRow.getCell(2).numFmt = "0%";      // or "0.00%"

        worksheet.addRow([]);

        // ===================================================
        // TABLE 2
        // ===================================================

        const header2 = worksheet.addRow([
            "Score Grade",
            "Min",
            "Max",
            "%",
            "Applicable %",
        ]);

        header2.eachCell((cell) => {
            cell.style = headerStyle;
        });

        calculatedGradeRows.forEach((r) => {
            const row = worksheet.addRow([
                r.scoreGrade,
                r.min,
                r.max,
                Number(r.percentage),
                Number(r.applicablePercentage),
            ]);

            row.getCell(4).numFmt = "0.00%";
            row.getCell(5).numFmt = "0.00%";

            row.eachCell((cell) => {
                cell.border = borderStyle;
            });
        });

        worksheet.addRow([]);

        // ===================================================
        // TABLE 3
        // ===================================================

        const header3 = worksheet.addRow([
            "Particulars",
            "Amount",
        ]);

        header3.eachCell((cell) => {
            cell.style = headerStyle;
        });

        [
            [
                "Operational Risk Pillar I Capital Charge",
                Number(operationalRiskCharge),
            ],
            [
                "Applicable % Capital Charge for Shariah Risk",
                totalApplicablePercentage,
            ],
            [
                "Capital Charge for Shariah Risk",
                capitalChargeForShariahRisk,
            ],
        ].forEach((item) => {
            const row = worksheet.addRow(item);

            // Apply percentage format only to the Applicable % row
            if (item[0] === "Applicable % Capital Charge for Shariah Risk") {
                row.getCell(2).numFmt = "0.00%";
            }

            row.eachCell((cell) => {
                cell.border = borderStyle;
            });
        });

        worksheet.addRow([]);

        // ===================================================
        // TABLE 4
        // ===================================================

        const displayedQuarterHeaders = getQuarterSequence(reportingDate);

        const header4 = worksheet.addRow(displayedQuarterHeaders);

        header4.eachCell((cell) => {
            cell.style = headerStyle;
        });

        const quarterRow = worksheet.addRow([
            Number(values[0]) || 0,
            Number(values[1]) || 0,
            Number(values[2]) || 0,
            Number(q4) || 0,
        ]);

        quarterRow.eachCell((cell) => {
            cell.border = borderStyle;
        });

        worksheet.addRow([]);

        // ===================================================
        // FINAL CAPITAL
        // ===================================================

        worksheet.mergeCells(`A${worksheet.rowCount + 1}:D${worksheet.rowCount + 1}`);

        const finalRow = worksheet.getRow(worksheet.rowCount + 1);

        finalRow.getCell(1).value = getFinalCapitalLabel(reportingDate);
        finalRow.getCell(5).value = finalCapitalCharge;

        finalRow.eachCell((cell) => {
            cell.font = {
                bold: true,
                color: { argb: "FFFFFF" },
            };

            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "0D6EFD" },
            };

            cell.border = borderStyle;
        });

        // -----------------------------
        // Download
        // -----------------------------

        const buffer = await workbook.xlsx.writeBuffer();

        saveAs(
            new Blob([buffer]),
            `Shariah_Risk_${reportingDate}.xlsx`
        );
    };

    return (
        <div
            className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}
            style={{
                backgroundImage: "none",
                backgroundColor: "#ffffff"
            }}
        >
            <Header />
            <Navigation />
            <main className="flex-grow-1 container-fluid" style={{ margin: 0, padding: 0, background: "none" }}>
                <div className={styles.mainContainer}>
                    <div className="container-fluid py-2">
                        <div className="row">
                            <div className="row">

                                {loading && (
                                    <div className="loading-overlay">
                                        <UploadLoadingIcon />
                                    </div>
                                )}

                                {!sheetData ? (
                                    <div className="card">
                                        <div className="card-body text-center">
                                            No Data Found
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        <div className="card-header bg-primary text-white">
                                            <h5 className="mb-0">
                                                Residual Operational Risk
                                            </h5>
                                        </div>

                                        <div className="row g-2">

                                            <div className="col-lg-4 col-md-12">
                                                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>

                                                    <div className="card-body">
                                                        <h5 className="mb-4">
                                                            Template Submission Process
                                                        </h5>


                                                        {/* Step 1 */}
                                                        <div className="list-group-item border-0 px-0 py-2">
                                                            <div className="d-flex align-items-center">
                                                                <div></div>
                                                            </div>
                                                        </div>

                                                        {/* Step 4 */}
                                                        <div className="list-group-item border-0 px-0 py-2">
                                                            <div className="d-flex align-items-center">

                                                                <span
                                                                    className={`badge rounded-circle p-2 me-3 ${isPreviewCompleted
                                                                        ? "bg-success"
                                                                        : isFileUploaded
                                                                            ? "bg-primary"
                                                                            : "bg-secondary"
                                                                        }`}
                                                                >
                                                                    {isPreviewCompleted ? (
                                                                        <i className="bi bi-check-lg"></i>
                                                                    ) : (
                                                                        "1"
                                                                    )}
                                                                </span>

                                                                <div>
                                                                    <div className="fw-semibold">
                                                                        Preview the submitted Operational Risk Residual data
                                                                    </div>

                                                                    <small
                                                                        className={
                                                                            isPreviewCompleted
                                                                                ? "text-success"
                                                                                : isFileUploaded
                                                                                    ? "text-primary"
                                                                                    : "text-muted"
                                                                        }
                                                                    >
                                                                        {isPreviewCompleted
                                                                            ? "Completed"
                                                                            : isFileUploaded
                                                                                ? "Next Step"
                                                                                : "Pending"}
                                                                    </small>
                                                                </div>

                                                            </div>
                                                        </div>

                                                        <div className="list-group-item border-0 px-0 py-2">
                                                            <div className="d-flex align-items-center">
                                                                <div></div>
                                                            </div>
                                                        </div>

                                                        {/* Step 5 - Approve / Reject */}
                                                        <div className="list-group-item border-0 px-0 py-2">
                                                            <div className="d-flex align-items-center">

                                                                <span
                                                                    className={`badge rounded-circle p-2 me-3 ${isSubmitted
                                                                        ? "bg-success"
                                                                        : isPreviewCompleted
                                                                            ? "bg-primary"
                                                                            : "bg-secondary"
                                                                        }`}
                                                                >
                                                                    {isSubmitted ? (
                                                                        <i className="bi bi-check-lg"></i>
                                                                    ) : (
                                                                        "2"
                                                                    )}
                                                                </span>

                                                                <div>
                                                                    <div className="fw-semibold">
                                                                        {isSubmitted
                                                                            ? "Override the Operational Risk Residual data"
                                                                            : confirmationAction === "approve"
                                                                                ? "Override With Remarks"
                                                                                : confirmationAction === "reject"
                                                                                    ? "Override With Remarks"
                                                                                    : "Override the Operational Risk Residual data"
                                                                        }
                                                                    </div>

                                                                    <small
                                                                        className={
                                                                            isSubmitted
                                                                                ? "text-success"
                                                                                : isPreviewCompleted
                                                                                    ? "text-primary"
                                                                                    : "text-muted"
                                                                        }
                                                                    >
                                                                        {isSubmitted
                                                                            ? "Completed"
                                                                            : confirmationAction === "approve"
                                                                                ? "Override Selected"
                                                                                : confirmationAction === "reject"
                                                                                    ? "Override Selected"
                                                                                    : isPreviewCompleted
                                                                                        ? "Next Step"
                                                                                        : "Pending"}
                                                                    </small>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* ── RIGHT col: tables ── */}
                                            <div className="col-lg-8 col-md-12">
                                                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                                    <div
                                                        className="card shadow-sm border"
                                                        style={{
                                                            borderRadius: "8px",
                                                            overflow: "hidden"
                                                        }}
                                                    >
                                                        {/* <div className={`tableWrapperLarge ${tableStyles.tableWrapperLarge}`}> */}

                                                        <div className="card-body p-0">

                                                            {/* =====================================================
                CARD HEADER
            ====================================================== */}
                                                            <div
                                                                className="px-4 py-3 d-flex justify-content-between align-items-center"
                                                                style={{
                                                                    backgroundColor: "#f8f9fa",
                                                                    borderBottom: "1px solid #dee2e6"
                                                                }}
                                                            >
                                                                <div className="d-flex align-items-center">

                                                                    <div
                                                                        className="d-flex align-items-center justify-content-center me-2"
                                                                        style={{
                                                                            width: "36px",
                                                                            height: "36px",
                                                                            borderRadius: "50%",
                                                                            backgroundColor: "#e8f1ff"
                                                                        }}
                                                                    >
                                                                        <i
                                                                            className="bi bi-file-earmark-excel-fill text-primary"
                                                                            style={{ fontSize: "18px" }}
                                                                        ></i>
                                                                    </div>

                                                                    <div>
                                                                        <div
                                                                            className="fw-semibold"
                                                                            style={{
                                                                                fontSize: "15px",
                                                                                color: "#343a40"
                                                                            }}
                                                                        >
                                                                            Residual Operational Risk
                                                                        </div>

                                                                        <small className="text-muted">
                                                                            Uploaded data for review
                                                                        </small>
                                                                    </div>

                                                                </div>



                                                            </div>


                                                            {/* =====================================================
                INFORMATION SECTION
            ====================================================== */}
                                                            <div className="px-4 py-3">

                                                                <div className="row g-3">

                                                                    {/* =================================================
        REPORTING DATE
    ================================================== */}
                                                                    <div className="col-md-5">
                                                                        <div
                                                                            className="border rounded p-3 h-100"
                                                                            style={{
                                                                                backgroundColor: "#ffffff"
                                                                            }}
                                                                        >
                                                                            <div className="d-flex align-items-center mb-2">

                                                                                <i
                                                                                    className="bi bi-calendar3 text-primary me-2"
                                                                                    style={{ fontSize: "16px" }}
                                                                                ></i>

                                                                                <span
                                                                                    className="text-muted fw-semibold"
                                                                                    style={{
                                                                                        fontSize: "11px",
                                                                                        letterSpacing: "0.3px"
                                                                                    }}
                                                                                >
                                                                                    REPORTING DATE
                                                                                </span>

                                                                            </div>

                                                                            <input
                                                                                id="reportingDate"
                                                                                type="text"
                                                                                className="form-control form-control-sm"
                                                                                style={{
                                                                                    width: "150px"
                                                                                }}
                                                                                value={reportingDate}
                                                                                readOnly
                                                                            />

                                                                        </div>
                                                                    </div>


                                                                    {/* =================================================
        REMARKS + PREVIEW
    ================================================== */}
                                                                    <div className="col-md-7">
                                                                        <div
                                                                            className="border rounded p-3 h-100"
                                                                            style={{
                                                                                backgroundColor: "#ffffff"
                                                                            }}
                                                                        >

                                                                            {/* Remarks Label + Value - Same Line */}
                                                                            <div className="d-flex align-items-start">

                                                                                <div
                                                                                    className="d-flex align-items-center me-3"
                                                                                    style={{
                                                                                        minWidth: "90px"
                                                                                    }}
                                                                                >
                                                                                    <i
                                                                                        className="bi bi-chat-left-text text-primary me-2"
                                                                                        style={{ fontSize: "16px" }}
                                                                                    ></i>

                                                                                    <span
                                                                                        className="text-muted fw-semibold"
                                                                                        style={{
                                                                                            fontSize: "11px",
                                                                                            letterSpacing: "0.3px"
                                                                                        }}
                                                                                    >
                                                                                        REMARKS
                                                                                    </span>
                                                                                </div>

                                                                                {/* Remarks Value */}
                                                                                <div
                                                                                    className={
                                                                                        !isNullValue(makerRemarks)
                                                                                            ? "text-danger fw-semibold"
                                                                                            : "text-muted"
                                                                                    }
                                                                                    style={{
                                                                                        fontSize: "14px",
                                                                                        wordBreak: "break-word",
                                                                                        lineHeight: "1.5",
                                                                                        flex: 1
                                                                                    }}
                                                                                >
                                                                                    {!isNullValue(makerRemarks)
                                                                                        ? makerRemarks
                                                                                        : "No remarks available"}
                                                                                </div>

                                                                            </div>


                                                                            {/* Preview Link - Below Remarks */}
                                                                            {showActionButtons && (
                                                                                <div className="mt-2">

                                                                                    <button
                                                                                        type="button"
                                                                                        onClick={handlePreviewOption}
                                                                                        className="btn btn-link p-0 text-primary text-decoration-none"
                                                                                        style={{
                                                                                            fontSize: "13px",
                                                                                            fontWeight: "500",
                                                                                            cursor: "pointer"
                                                                                        }}
                                                                                        title="Preview submitted data"
                                                                                    >
                                                                                        <i className="bi bi-eye me-1"></i>
                                                                                        Click here to preview the uploaded data
                                                                                    </button>

                                                                                </div>
                                                                            )}

                                                                        </div>
                                                                    </div>

                                                                </div>


                                                                {showDownload && (
                                                                    <div className="mt-3">

                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-success btn-sm"
                                                                            disabled={!reportingDate}
                                                                            onClick={handleDownload}
                                                                        >
                                                                            <i className="bi bi-download me-1"></i>
                                                                            Download
                                                                        </button>

                                                                    </div>
                                                                )}


                                                                {/* =====================================================
                    EXISTING FILE AREA
                ====================================================== */}
                                                                <div className="col-md-6">
                                                                    <div className="mb-3">
                                                                        <div className="flex-grow-1 justify-content-center w-100">

                                                                            <div className="d-flex flex-column align-items-center gap-2 mt-2">
                                                                                {/* {selectedFile && (

                                )} */}
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </div>


                                                                {/* =====================================================
                    ACTION BUTTONS
                ====================================================== */}
                                                                {showActionButtons && (
                                                                    <div
                                                                        className="d-flex justify-content-end align-items-center mt-3"
                                                                    >


                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-light btn-sm custom-btn"
                                                                            data-toggle="tooltip"
                                                                            data-placement="Left"
                                                                            title="Click to Override"
                                                                            // disabled={!isSubmitEnabled || isViewMode}
                                                                            // onClick={() => setShowConfirmApprove(true)}
                                                                            onClick={() => {
                                                                                setInputValue("");
                                                                                SetshowMakerremarks(true);
                                                                            }}
                                                                            style={{
                                                                                ...Aprrovecolor,
                                                                                color: "white",
                                                                                // marginRight: "10px",
                                                                                // pointerEvents: isSubmitEnabled ? "auto" : "none",
                                                                            }}
                                                                        >
                                                                            Override
                                                                        </button>


                                                                    </div>
                                                                )}
                                                            </div>

                                                        </div>


                                                        <>
                                                            <style>
                                                                {`
                    .excel-print-preview {
                        background: #f5f5f5;
                        padding: 25px;
                        overflow-x: auto;
                    }

                    .excel-table-section {
                        background: #ffffff;
                        width: fit-content;
                        min-width: fit-content;
                        margin: 0 auto 28px auto;
                        padding: 20px;
                        box-shadow: 0 1px 5px rgba(0, 0, 0, 0.12);
                    }

                    .excel-real-table {
                        border-collapse: collapse;
                        table-layout: auto;
                        width: auto;
                        min-width: 0;
                    }

                    .excel-real-table td {
                        border: 1px solid #000;
                        padding: 5px 8px;
                        white-space: nowrap;
                        vertical-align: middle;
                        font-family: Calibri, Arial, sans-serif;
                        font-size: 11pt;
                    }

                    .excel-real-table td:empty {
                        min-width: 0;
                    }
                `}
                                                            </style>

                                                            {/* Your existing page */}

                                                            {showPreview && (
                                                                <Modal
                                                                    show={showPreview}
                                                                    onHide={handleCloseModal}
                                                                    dialogClassName="modal-xl"
                                                                    centered
                                                                >
                                                                    <Modal.Header className="bg-light border-bottom px-0 py-2">
                                                                        <div className="container-fluid px-0">
                                                                            <div className="row align-items-center w-100 gx-0">

                                                                                <div className="col-auto ps-3">
                                                                                    <h6 className="mb-0">
                                                                                        <strong>Table Name:</strong>{" "}
                                                                                        <span>
                                                                                            Residual Operational Risk
                                                                                        </span>
                                                                                    </h6>
                                                                                </div>

                                                                                <div className="col-auto ms-auto">
                                                                                    <div className="d-flex justify-content-end pe-3">
                                                                                        <button
                                                                                            onClick={handleCloseModal}
                                                                                            type="button"
                                                                                            className="btn-close"
                                                                                            aria-label="Close"
                                                                                        />
                                                                                    </div>
                                                                                </div>

                                                                            </div>
                                                                        </div>
                                                                    </Modal.Header>

                                                                    <Modal.Body
                                                                        style={{
                                                                            overflow: "auto",
                                                                            maxHeight: "75vh",
                                                                            background: "#f5f5f5"
                                                                        }}
                                                                    >
                                                                        <div
                                                                            className="excel-print-preview"
                                                                            dangerouslySetInnerHTML={{
                                                                                __html: previewSheetData
                                                                            }}
                                                                        />
                                                                    </Modal.Body>
                                                                </Modal>
                                                            )}
                                                        </>

                                                        <Modal
                                                            show={showModal}
                                                            style={{ marginTop: "12vh" }}
                                                        >
                                                            <div
                                                                className={`alert alert-${messageType === "success"
                                                                    ? "success"
                                                                    : "danger"
                                                                    } fade show`}
                                                                role="alert"
                                                                style={{
                                                                    marginBottom: "0",
                                                                    maxHeight: "80vh",
                                                                    overflowY: "auto"
                                                                }}
                                                            >

                                                                <div className="d-flex align-items-center">

                                                                    {messageType === "success" ? (
                                                                        <span
                                                                            className="me-2"
                                                                            style={{ color: "green" }}
                                                                        >
                                                                            ✅
                                                                        </span>
                                                                    ) : (
                                                                        <span
                                                                            className="me-2"
                                                                            style={{ color: "red" }}
                                                                        >
                                                                            ❌
                                                                        </span>
                                                                    )}

                                                                    <p
                                                                        style={{
                                                                            marginBottom: "0px",
                                                                            color:
                                                                                messageType === "success"
                                                                                    ? "green"
                                                                                    : "red",
                                                                            fontSize: "14px",
                                                                            whiteSpace: "pre-wrap"
                                                                        }}
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: modalMessage.replace(
                                                                                /\n/g,
                                                                                "<br />"
                                                                            )
                                                                        }}
                                                                    ></p>

                                                                </div>

                                                                <button
                                                                    type="button"
                                                                    className="btn-close position-absolute top-0 end-0 m-2"
                                                                    style={{ fontSize: "10px" }}
                                                                    onClick={handleCloseSuccessModal}
                                                                >
                                                                </button>

                                                            </div>
                                                        </Modal>


                                                        {/* =====================================================
            MAKER REMARKS MODAL
            UNCHANGED
        ====================================================== */}
                                                        <Modal
                                                            show={showmakerRemarks}
                                                            onHide={handleCloseMakerPOP}
                                                            centered
                                                            backdrop="static"
                                                            keyboard={false}
                                                        >
                                                            <Modal.Header
                                                                style={{
                                                                    backgroundColor: "#366872",
                                                                    color: "white",
                                                                    padding: "0.5rem 1rem"
                                                                }}
                                                            >
                                                                <Modal.Title style={{ fontSize: "16px" }}>
                                                                    Remarks
                                                                </Modal.Title>
                                                            </Modal.Header>

                                                            <Modal.Body
                                                                className="text-break overflow-auto"
                                                                style={{
                                                                    padding: "0.75rem 1rem",
                                                                    fontSize: "14px",
                                                                    maxHeight: "60vh"
                                                                }}
                                                            >
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="Enter your remarks"
                                                                    value={inputValue}
                                                                    onChange={(e) =>
                                                                        setInputValue(e.target.value)
                                                                    }
                                                                />
                                                            </Modal.Body>

                                                            <Modal.Footer style={{ borderTop: "none" }}>

                                                                <Button
                                                                    variant="btn btn-outline-secondary btn-sm mx-2"
                                                                    style={cancelButtonStyle}
                                                                    onClick={handleCloseMakerPOP}
                                                                >
                                                                    Close
                                                                </Button>

                                                                <Button
                                                                    variant="btn btn-success btn-sm mx-2"
                                                                    onClick={handleRemarksSubmit}
                                                                >
                                                                    Submit
                                                                </Button>

                                                            </Modal.Footer>
                                                        </Modal>

                                                        <Modal
                                                            show={showmakerRemarks1}
                                                            onHide={handleCloseMakerPOP}
                                                            centered
                                                            backdrop="static"
                                                            keyboard={false}
                                                        >
                                                            <Modal.Header
                                                                style={{
                                                                    backgroundColor: "#366872",
                                                                    color: "white",
                                                                    padding: "0.5rem 1rem"
                                                                }}
                                                            >
                                                                <Modal.Title style={{ fontSize: "16px" }}>
                                                                    Remarks
                                                                </Modal.Title>
                                                            </Modal.Header>

                                                            <Modal.Body
                                                                className="text-break overflow-auto"
                                                                style={{
                                                                    padding: "0.75rem 1rem",
                                                                    fontSize: "14px",
                                                                    maxHeight: "60vh"
                                                                }}
                                                            >
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="Enter your remarks"
                                                                    value={inputValue1}
                                                                    onChange={(e) =>
                                                                        setInputValue1(e.target.value)
                                                                    }
                                                                />
                                                            </Modal.Body>

                                                            <Modal.Footer style={{ borderTop: "none" }}>

                                                                <Button
                                                                    variant="btn btn-outline-secondary btn-sm mx-2"
                                                                    style={cancelButtonStyle}
                                                                    onClick={handleCloseMakerPOP}
                                                                >
                                                                    Close
                                                                </Button>

                                                                <Button
                                                                    variant="btn btn-success btn-sm mx-2"
                                                                    onClick={handleApproveSubmit}
                                                                >
                                                                    Submit
                                                                </Button>

                                                            </Modal.Footer>
                                                        </Modal>

                                                        {/* </div> */}

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}

                                <Modal show={showConfirmApprove} onHide={() => setShowConfirmApprove(false)} backdrop="static" keyboard={false} style={{ marginTop: '12vh' }}>
                                    <Modal.Header
                                        style={{
                                            backgroundColor: '#366872',
                                            color: 'white',
                                            padding: '0.5rem 1rem'
                                        }}
                                        closeButton>
                                        <Modal.Title style={{ fontSize: '16px' }}>Confirm Approval</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}>
                                        <p>Are you sure you want to Approve this record?</p>
                                    </Modal.Body >
                                    <Modal.Footer style={{ borderTop: 'none' }}>
                                        <Button variant="secondary"
                                            style={
                                                cancelButtonStyle
                                            } onClick={() => setShowConfirmApprove(false)}>Cancel</Button>
                                        <Button
                                            variant="Primary"
                                            style={submitButtonStyle}
                                            onClick={() => {
                                                setShowConfirmApprove(false);
                                                handleBulkApprove();
                                            }}
                                        >
                                            Submit
                                        </Button>
                                    </Modal.Footer>
                                </Modal>



                                <Modal
                                    show={showModal}
                                    onHide={handleCancel}
                                    style={{ marginTop: '12vh' }}
                                >
                                    <div className={`alert alert-${messageType === 'success' ? 'success' : 'danger'} fade show`} role="alert"
                                        style={{ marginBottom: '0', maxHeight: '80vh', overflowY: 'auto' }}>

                                        <div className="d-flex align-items-center">
                                            {messageType === 'success' ? (
                                                <span className="me-2" style={{ color: 'green' }}>✅</span>
                                            ) : (
                                                <span className="me-2" style={{ color: 'red' }}>❌</span>
                                            )}
                                            <p
                                                style={{
                                                    marginBottom: '0px',
                                                    color: messageType === 'success' ? 'green' : 'red',
                                                    fontSize: '14px',
                                                    whiteSpace: 'pre-wrap' // optional, if you want to preserve spaces or indentation
                                                }}
                                                dangerouslySetInnerHTML={{
                                                    __html: modalMessage.replace(/\n/g, '<br />')
                                                }}
                                            ></p>



                                        </div>
                                        <button
                                            type="button"
                                            className="btn-close position-absolute top-0 end-0 m-2" style={{ fontSize: '10px' }}
                                            onClick={handleCancel}>
                                        </button>

                                    </div>
                                </Modal>

                                <Modal
                                    show={showChargeModal}
                                    onHide={() => setShowChargeModal(false)}
                                    centered
                                    size="xl"
                                >
                                    <Modal.Header
                                        style={{
                                            backgroundColor: '#366872',
                                            color: 'white',
                                            padding: '0.5rem 1rem'
                                        }}
                                        closeButton>
                                        <Modal.Title style={{ fontSize: '16px' }}>
                                            Select Reporting Date for Comparison
                                        </Modal.Title>
                                    </Modal.Header>

                                    <Modal.Body>

                                        {/* ============================= */}
                                        {/* REPORTING DATE SELECTION */}
                                        {/* ============================= */}

                                        <div
                                            style={{
                                                display: 'flex',
                                                gap: '25px',
                                                alignItems: 'center',
                                                marginBottom: '5px',
                                                padding: '8px 0'
                                            }}
                                        >

                                            <strong>
                                                Reporting Date:
                                            </strong>

                                            {reportingDates1.map(date => (

                                                <Form.Check
                                                    key={date}
                                                    type="checkbox"
                                                    label={date}
                                                    checked={selectedReportingDate1.includes(date)}
                                                    onChange={(e) => {

                                                        if (e.target.checked) {

                                                            setselectedReportingDate1(prev => [
                                                                ...prev,
                                                                date
                                                            ]);

                                                        } else {

                                                            setselectedReportingDate1(prev =>
                                                                prev.filter(item => item !== date)
                                                            );

                                                        }

                                                    }}
                                                />

                                            ))}

                                        </div>


                                        {/* ============================= */}
                                        {/* SHOW DATA ONLY AFTER SELECTION */}
                                        {/* ============================= */}

                                        {selectedReportingDate1.length > 0 && (

                                            <div style={{ overflowX: 'auto' }}>

                                                <table
                                                    className={`table table-bordered text-center ${tableStyles.customScrollTable}`}
                                                    style={{
                                                        verticalAlign: 'middle',
                                                        // minWidth: '1000px'
                                                    }}
                                                >

                                                    <thead>

                                                        {/* FIRST HEADER ROW */}

                                                        <tr>
                                                            <th
                                                                rowSpan="2"
                                                                style={{
                                                                    backgroundColor: '#366872',
                                                                    color: 'white'
                                                                }}
                                                            >
                                                                Key Areas
                                                            </th>

                                                            <th
                                                                rowSpan="2"
                                                                style={{
                                                                    backgroundColor: '#366872',
                                                                    color: 'white'
                                                                }}
                                                            >
                                                                Weight
                                                            </th>

                                                            {/* Space between Weight and first Reporting Date */}
                                                            <th
                                                                rowSpan="2"
                                                                style={{
                                                                    width: '20px',
                                                                    minWidth: '20px',
                                                                    padding: 0,
                                                                    border: 'none',
                                                                    backgroundColor: 'white'
                                                                }}
                                                            >
                                                            </th>

                                                            {capitalChargeData.map((dateData, index) => (
                                                                <React.Fragment key={index}>

                                                                    {/* Reporting Date */}
                                                                    <th
                                                                        colSpan="2"
                                                                        style={{
                                                                            backgroundColor: '#366872',
                                                                            color: 'white'
                                                                        }}
                                                                    >
                                                                        Period: {dateData.reportingDate}
                                                                    </th>

                                                                    {/* Space after Reporting Date */}
                                                                    <th
                                                                        rowSpan="2"
                                                                        style={{
                                                                            width: '20px',
                                                                            minWidth: '20px',
                                                                            padding: 0,
                                                                            border: 'none',
                                                                            backgroundColor: 'white'
                                                                        }}
                                                                    >
                                                                    </th>

                                                                </React.Fragment>
                                                            ))}
                                                        </tr>


                                                        {/* SECOND HEADER ROW */}

                                                        <tr>
                                                            {capitalChargeData.map((dateData, index) => (
                                                                <React.Fragment key={index}>

                                                                    {/* Observations */}
                                                                    <th
                                                                        style={{
                                                                            backgroundColor: '#366872',
                                                                            color: 'white',
                                                                            fontSize: '12px'
                                                                        }}
                                                                    >
                                                                        No. of Observations
                                                                    </th>

                                                                    {/* Impact */}
                                                                    <th
                                                                        style={{
                                                                            backgroundColor: '#366872',
                                                                            color: 'white',
                                                                            fontSize: '12px'
                                                                        }}
                                                                    >
                                                                        Impact Scale
                                                                        <br />
                                                                        (1 to 10)
                                                                    </th>

                                                                </React.Fragment>
                                                            ))}
                                                        </tr>

                                                    </thead>


                                                    {/* BODY */}

                                                    <tbody>

                                                        {capitalChargeData.length > 0 &&
                                                            capitalChargeData[0].rows?.map(
                                                                (commonRow, rowIndex) => (

                                                                    <tr key={rowIndex}>

                                                                        {/* KEY AREA */}

                                                                        <td
                                                                            style={{
                                                                                textAlign: 'left',
                                                                                fontWeight: '500'
                                                                            }}
                                                                        >
                                                                            {commonRow.key_areas === "\\N"
                                                                                ? ""
                                                                                : commonRow.key_areas ?? ""}
                                                                        </td>


                                                                        {/* WEIGHT */}

                                                                        <td>
                                                                            {commonRow.weight_a === "\\N"
                                                                                ? ""
                                                                                : commonRow.weight_a ?? ""}
                                                                        </td>

                                                                        {/* SPACE BETWEEN WEIGHT AND REPORTING DATE */}

                                                                        <td
                                                                            style={{
                                                                                width: '20px',
                                                                                minWidth: '20px',
                                                                                padding: 0,
                                                                                border: 'none',
                                                                                backgroundColor: 'white'
                                                                            }}
                                                                        >
                                                                        </td>

                                                                        {/* SELECTED REPORTING DATES */}

                                                                        {capitalChargeData.map(
                                                                            (dateData, dateIndex) => {

                                                                                const currentRow =
                                                                                    dateData.rows?.find(
                                                                                        row =>
                                                                                            row.key_areas ===
                                                                                            commonRow.key_areas
                                                                                    );
                                                                                const displayValue = (value) => {
                                                                                    return value === "\\N" || value === null || value === undefined
                                                                                        ? ""
                                                                                        : value;
                                                                                };
                                                                                return (

                                                                                    <React.Fragment key={dateIndex}>

                                                                                        <td>
                                                                                            {displayValue(currentRow?.observations)}
                                                                                        </td>

                                                                                        <td>
                                                                                            {displayValue(currentRow?.impact)}
                                                                                        </td>

                                                                                        {/* SPACE AFTER REPORTING DATE */}
                                                                                        <td
                                                                                            style={{
                                                                                                width: '20px',
                                                                                                minWidth: '20px',
                                                                                                padding: 0,
                                                                                                border: 'none',
                                                                                                backgroundColor: 'white'
                                                                                            }}
                                                                                        >
                                                                                        </td>

                                                                                    </React.Fragment>

                                                                                );

                                                                            }
                                                                        )}

                                                                    </tr>

                                                                )
                                                            )
                                                        }

                                                    </tbody>


                                                    {/* FINAL CAPITAL CHARGE */}

                                                    <tfoot>

                                                        <tr>

                                                            {/* Key Areas + Weight + SPACE */}
                                                            <th
                                                                colSpan="3"
                                                                style={{
                                                                    backgroundColor: '#366872',
                                                                    color: 'white'
                                                                }}
                                                            >
                                                                Final Capital Charge (SAR 000's)
                                                            </th>

                                                            {capitalChargeData.map((row, index) => (
                                                                <React.Fragment key={index}>

                                                                    {/* Capital Charge */}
                                                                    <td
                                                                        colSpan="2"
                                                                        style={{
                                                                            fontWeight: 'bold'
                                                                        }}
                                                                    >
                                                                        {/* {row.capitalCharge === "\\N"
                                                                            ? ""
                                                                            : row.capitalCharge ?? ""} */}
                                                                        {formatNumber(row.capitalCharge)}
                                                                    </td>

                                                                    {/* SPACE AFTER EACH REPORTING DATE */}
                                                                    <td
                                                                        style={{
                                                                            width: '20px',
                                                                            minWidth: '20px',
                                                                            padding: 0,
                                                                            border: 'none',
                                                                            backgroundColor: 'white'
                                                                        }}
                                                                    >
                                                                    </td>

                                                                </React.Fragment>
                                                            ))}

                                                        </tr>

                                                    </tfoot>

                                                </table>

                                            </div>

                                        )}

                                    </Modal.Body>

                                    <Modal.Footer style={{ borderTop: 'none' }}>

                                        <Button variant="btn btn-outline-secondary btn-sm mx-2" style={cancelButtonStyle}
                                            onClick={() => setShowChargeModal(false)}
                                        >
                                            Close
                                        </Button>

                                    </Modal.Footer>

                                </Modal>


                                <Modal
                                    show={showReportingModal}
                                    onHide={handleCloseReportingModal}
                                    centered
                                    backdrop="static"
                                >
                                    <Modal.Header
                                        style={{
                                            backgroundColor: '#366872',
                                            color: 'white',
                                            padding: '0.5rem 1rem'
                                        }}
                                        closeButton>
                                        <Modal.Title style={{ fontSize: '16px' }}>
                                            Select Reporting Date
                                        </Modal.Title>
                                    </Modal.Header>

                                    <Modal.Body>

                                        {reportingDates1.map(date => (

                                            <Form.Check
                                                key={date}
                                                type="checkbox"
                                                label={date}
                                                checked={selectedReportingDate1.includes(date)}
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        setselectedReportingDate1(prev => [...prev, date]);
                                                    } else {
                                                        setselectedReportingDate1(prev =>
                                                            prev.filter(item => item !== date)
                                                        );
                                                    }
                                                }}
                                            />

                                        ))}

                                    </Modal.Body>

                                    <Modal.Footer style={{ borderTop: 'none' }}>

                                        <Button variant="btn btn-outline-secondary btn-sm mx-2" style={cancelButtonStyle}
                                            onClick={handleCloseReportingModal}
                                        >
                                            Close
                                        </Button>

                                        <Button variant="btn btn-success btn-sm"
                                            style={
                                                submitButtonStyle
                                            }
                                            disabled={selectedReportingDate1.length === 0}
                                            onClick={handleReportingDateSubmit}
                                        >
                                            Submit
                                        </Button>

                                    </Modal.Footer>

                                </Modal>

                                <Modal
                                    show={showRejectModal}
                                    onHide={() => setShowRejectModal(false)}
                                    backdrop="static"
                                    keyboard={false}
                                    size="lg"
                                    style={{ marginTop: '12vh' }}
                                >
                                    <Modal.Header
                                        style={{
                                            backgroundColor: '#366872',
                                            color: 'white',
                                            padding: '0.5rem 1rem'
                                        }}
                                        closeButton>
                                        <Modal.Title style={{ fontSize: '16px' }}>Reason for Rejection</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}>
                                        <div className="form-group">
                                            <label htmlFor="column-select" className="text-secondary">Select Reason</label>

                                            <select
                                                className="form-control"
                                                id="column-select"
                                                onChange={handleColumnSelect}
                                                value={selectedColumn}
                                            >
                                                <option value="">
                                                    Select Reason
                                                </option>

                                                {rejectColumns.map((column, index) => (
                                                    <option
                                                        key={index}
                                                        value={column.value}
                                                    >
                                                        {column.label} is not correct
                                                    </option>
                                                ))}

                                                <option value="DeleteRecord">
                                                    Delete the record
                                                </option>

                                                <option value="Others">
                                                    Others
                                                </option>
                                            </select>

                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="other-reason" className="text-secondary">Reason Details</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="reason-input"
                                                id="other-reason"
                                                value={otherReason}
                                                onChange={handleOtherReasonChange}
                                                placeholder="Provide Reason here..."
                                                required={isReasonRequired}
                                            />
                                        </div>
                                    </Modal.Body>
                                    <Modal.Footer style={{ borderTop: 'none' }}>
                                        <Button
                                            variant="secondary"
                                            onClick={() => setShowRejectModal(false)}
                                            style={cancelButtonStyle}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            variant="primary"
                                            onClick={handleReasonSubmit}
                                            disabled={isSubmitDisabled}

                                            style={
                                                ProceedButtonStyle
                                            }
                                        >
                                            Proceed
                                        </Button>
                                    </Modal.Footer>
                                </Modal>

                                <Modal
                                    show={showReportingModal}
                                    onHide={() => {
                                        setShowReportingModal(false);
                                        // setReportingDate("");
                                        setAllowSubmit(false);
                                    }}
                                    backdrop="static"
                                    keyboard={false}
                                    style={{ marginTop: "12vh" }}
                                >
                                    <Modal.Header
                                        style={{
                                            backgroundColor: '#366872',
                                            color: 'white',
                                            padding: '0.5rem 1rem'
                                        }}
                                        closeButton>
                                        <Modal.Title style={{ fontSize: '16px' }}>
                                            Reporting Date Validation
                                        </Modal.Title>
                                    </Modal.Header>

                                    <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}>
                                        {reportingMessage}
                                    </Modal.Body>

                                    <Modal.Footer style={{ borderTop: 'none' }}>
                                        <Button
                                            variant="Primary"
                                            style={
                                                submitButtonStyle
                                            }
                                            onClick={() => {
                                                setShowReportingModal(false);
                                                // setReportingDate("");
                                                setAllowSubmit(false);
                                                restoreExcelValues();
                                            }}
                                        >
                                            OK
                                        </Button>
                                    </Modal.Footer>
                                </Modal>
                                <Modal show={showmakerRemarks} onHide={handleCloseMakerPOP} centered backdrop="static" keyboard={false}>
                                    <Modal.Header
                                        style={{
                                            backgroundColor: '#366872',
                                            color: 'white',
                                            padding: '0.5rem 1rem'
                                        }}
                                    >
                                        <Modal.Title style={{ fontSize: '16px' }}>Remarks</Modal.Title>
                                    </Modal.Header>

                                    <Modal.Body className="text-break overflow-auto" style={{ padding: '0.75rem 1rem', fontSize: '14px', maxHeight: "60vh" }}>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter your remarks"
                                            value={inputValue}
                                            onChange={(e) => setInputValue(e.target.value)}
                                        />
                                    </Modal.Body>

                                    <Modal.Footer style={{ borderTop: 'none' }}>
                                        <Button variant="btn btn-outline-secondary btn-sm mx-2" style={cancelButtonStyle} onClick={handleCloseMakerPOP}>
                                            Close
                                        </Button>
                                        <Button variant="btn btn-success btn-sm mx-2" onClick={handleUploadedtoSama}>
                                            Submit
                                        </Button>
                                    </Modal.Footer>
                                </Modal>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default GapsyResidualOverride;